import { InfoCircleOutlined } from '@ant-design/icons'
import { Button, Modal } from '@surecompanies/core_components'
import React, { useState } from 'react'
import DemoPresetsSummary from './DemoPresetsSummary'

/**
 * A button + modal that surfaces the full list of auto-applied demo presets.
 * Drop this anywhere — it manages its own open/close state internally.
 */
export default function DemoPresetsModal() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        type="link"
        icon={<InfoCircleOutlined />}
        onClick={() => setOpen(true)}
        style={{ padding: 0 }}
      >
        View auto-applied presets
      </Button>

      <Modal
        title="Auto-applied Presets"
        open={open}
        onCancel={() => setOpen(false)}
        footer={<Button onClick={() => setOpen(false)}>Close</Button>}
        width={640}
        styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
        destroyOnClose
      >
        <DemoPresetsSummary />
      </Modal>
    </>
  )
}
